"use client";
import Image from "next/image";
import React from "react";
import AboutUsCard from "./AboutUsCard";
import OurTeam from "../home/our-team-section/OurTeam";
import DepartmentCard from "./DepartmentCard";
import {
  aboutUsBanner,
  aboutFocusKeys,
  whyChooseUsPoints,
  departmentList,
} from "@/data/about-us.data";
import { useDict } from "@/components/providers/LocaleProvider";

const AboutUs = () => {
  const t = useDict();
  return (
    <section className="space-y-8 lg:space-y-16">
      <Image
        src={aboutUsBanner.image}
        alt={t.aboutUs.banner.title}
        width={1000}
        height={300}
        className="w-full h-fit max-h-[500px] object-cover object-center rounded-bl-[60px] lg:rounded-bl-[120px] rounded-tr-[60px] lg:rounded-tr-[120px] shadow-lg"
      />

      <section className="grid grid-cols-1 md:grid-cols-2">
        {aboutFocusKeys.map((key, index) => {
          const item = t.aboutUs.focus[key];
          return (
            <AboutUsCard
              key={key}
              title={item.title}
              description={item.description}
              index={index + 1}
            />
          );
        })}
      </section>

      <section className="w-full space-y-10">
        <OurTeam />
      </section>

      <section className="space-y-4 lg:space-y-8">
        <h1 className="!card-title text-center" style={{ fontSize: "36px" }}>
          {t.aboutUs.whyChooseUs.title}
        </h1>

        <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
          {whyChooseUsPoints.map(({ key, icon }) => {
            const point = t.aboutUs.whyChooseUs.points[key];
            return (
              <div
                key={key}
                className="p-6 bg-gradient-to-b from-primary to-primary/80 rounded-lg gap-4 mb-4 overflow-hidden"
              >
                <div className="flex gap-2 items-center w-full hover:scale-105 transition-all duration-300 ease-in-out">
                  <Image
                    src={icon}
                    alt={point.title}
                    width={64}
                    height={64}
                    className="h-20 w-20 object-cover object-center"
                  />

                  <div className="flex flex-col gap-1">
                    <p className="card-title">{point.title}</p>
                    <p className="card-description text-light-text">
                      {point.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </section>
      </section>

      <section className="space-y-4 lg:space-y-8">
        <h1
          className="section-title text-center text-2xl md:text-3xl lg:text-4xl"
          style={{ fontSize: "36px" }}
        >
          {t.aboutUs.departments.title}
        </h1>

        <section className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
          {departmentList.map(({ key, Icon, image }) => {
            const dept = t.aboutUs.departments.items[key];
            return (
              <DepartmentCard
                key={key}
                data={{
                  Icon,
                  image,
                  title: dept.title,
                  description: dept.description,
                }}
              />
            );
          })}
        </section>
      </section>
    </section>
  );
};

export default AboutUs;
